import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import api from "../../../api/api";
import { useDocumentModal } from "../../common/CustomModal/CustomModalContext";

import DocumentRenameModal from "./DocumentRenameModal";

function DocumentRenameComponent({ docId, refetchDocumentData }) {
  const [documentName, setDocumentName] = useState("");
  const { toggle, setDocumentData } = useDocumentModal();
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const renameInputRef = useRef(null);
  const saveButtonRef = useRef(null);

  useEffect(() => {
    if (isModalOpen) return;

    const handleClickOutside = (event) => {
      if (
        !renameInputRef.current?.contains(event.target) &&
        !saveButtonRef.current?.contains(event.target)
      ) {
        setDocumentName("");
        setError(null);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside, true);
    return () => document.removeEventListener("pointerdown", handleClickOutside, true);
  }, [isModalOpen]);

  const handleSave = () => {
    const cleanName = documentName.replace(/\.pdf/gi, "");
    if (!cleanName || cleanName.length < 3) {
      setError("Document name must be at least 3 characters long.");
      return; // Exit the function if validation fails
    }
    setIsModalOpen(true);
  };

  const handleConfirm = async () => {
    const cleanName = documentName.replace(/\.pdf/gi, "");
    try {
      await api.put("/api/rename-doc/", {
        doc_id: docId,
        doc_rename: cleanName,
      });
      setError(null);

      setDocumentData((prevData) => ({
        ...prevData,
        file_name: documentName,
      }));
      if (typeof refetchDocumentData === "function") {
        await refetchDocumentData();
      }
      toggle();
    } catch (error) {
      setError(error.response?.data?.message || "An unexpected error occurred");
    }
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        className="tile-row d-flex flex-column w-100 p-l-5 p-r-5 p-t-5 p-b-5"
        style={{
          background: "var(--primary-4)",
          gap: "5px",
        }}
      >
        <div className="input-wrap w-100">
          <input
            ref={renameInputRef}
            className="form-control w-100 height-25 p-l-5 document-search-text-color"
            id="document_rename"
            aria-label="Rename Document"
            placeholder="Rename Document"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            style={{ height: "21px", fontWeight: "600" }}
          />
          {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
        </div>
        <button
          ref={saveButtonRef}
          type="button"
          className={`btn text-white w-100 d-flex justify-content-center align-items-center doc-pop-visibility-visible doc-pop-height-25px ${documentName ? "btn-success" : "btn-secondary"}`}
          disabled={!documentName}
          onClick={handleSave}
          style={{
            height: "21px",
            fontSize: "14px",
            fontWeight: "600",
            padding: "5px",
          }}
        >
          Save New Document Name
        </button>
      </div>
      {isModalOpen && (
        <DocumentRenameModal
          isOpen={isModalOpen}
          documentName={documentName}
          onConfirm={handleConfirm}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}

DocumentRenameComponent.propTypes = {
  docId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  refetchDocumentData: PropTypes.func,
};
export default DocumentRenameComponent;
